import {inject, observer} from 'mobx-react';
import DepositRedirectSystemClass from './DepositRedirectSystemClass';

@inject('depositsStore')
@observer
export default class DepositInstantRedirectSystem extends DepositRedirectSystemClass {
    preparedPath = (): string => null;
}
